import { Subject } from 'rxjs';

// Owned by one suggestions panel. Reset cancels this book's requests without
// disposing the owner, so the same panel can load another book immediately.
export class AdjustmentPanelQueries {
    private readonly pending = new Set<() => void>();

    cancelAll(): void { Array.from(this.pending).forEach(cancel => cancel()); }

    query<T>(start: (cancelled: Subject<void>) => Promise<T>): Promise<T> {
        return new Promise((resolve, reject) => {
            const cancelled = new Subject<void>();
            let settled = false;
            const finish = (error?: Error, value?: T) => {
                if (settled) { return; }
                settled = true; clearTimeout(guard); this.pending.delete(cancel);
                if (error) { reject(error); cancelled.next(); } else { resolve(value); }
                cancelled.complete();
            };
            const cancel = () => finish(new Error('Adjustment Query Cancelled.'));
            const guard = setTimeout(() => finish(new Error('Adjustment Query Timed Out.')), 15000);
            this.pending.add(cancel);
            try { start(cancelled).then(value => finish(undefined, value), error => finish(error)); }
            catch (error) { finish(error); }
        });
    }
}
